import {
    apiRequest,
    processInput,
    addNewFilter,
    processQueryParams,
    isEmpty
} from "@/utilities"
import { unpackCoach, unpackCourseStart, unpackEmails } from "@/modules"

const state = {
    loading: false,
    reconciliationOverrides: [],
    loadedActualData: false,
}

const getters = {
    reconciliationOverrides: (state, getters, rootState, rootGetters) => {
        return state.reconciliationOverrides
    },
    reconciliationOverrideByType: (state, getters, rootState, rootGetters) => (type, uuid) => {
        return state.reconciliationOverrides.find(i => i.assignable_type == type && i.assignable_uuid == uuid)
    },
    reconciliationOverrideByCourseStartUuid: (state, getters, rootState, rootGetters) => (courseStartUuids) => {
        return state.reconciliationOverrides.filter(i => courseStartUuids.includes(i.course_starts_uuid))
    },
}

const actions = {
    async getReconciliationOverrides({ commit }, params) {
        commit("RECONCILIATION_OVERRIDES_REQUEST")
    },
    async createReconciliationOverride({ commit }, params) {
        commit("CREATE_RECONCILIATION_OVERRIDE_REQUEST")
        const createData = processInput(params)
        const createReconciliationOverrideRequest = {
            method: "POST",
            data: createData
        }
        const response = await apiRequest(`/api/reconciliation-overrides`, createReconciliationOverrideRequest)
        const { status, data } = response
        switch (status) {
            case 200:
                commit("CREATE_RECONCILIATION_OVERRIDE_SUCCESS", data)
                break
            default:
                commit("CREATE_RECONCILIATION_OVERRIDE_ERROR", data)
        }
    },
    async editReconciliationOverride({ commit }, params) {
        commit("RECONCILIATION_OVERRIDE_REQUEST")
        switch (status) {
            case 200:
                commit("EDIT_RECONCILIATION_OVERRIDE_SUCCESS", data)
                break
            default:
                commit("EDIT_RECONCILIATION_OVERRIDE_ERROR", data)
        }
    },
}

const mutations = {
    RECONCILIATION_OVERRIDES_REQUEST: state => {
        state.loading = true
    },
    GET_RECONCILIATION_OVERRIDES_SUCCESS: (state, data) => {
        const reconciliationOverrides = data.reconciliation_overrides
        state.reconciliationOverrides = addNewFilter(state.reconciliationOverrides, reconciliationOverrides)
        state.loading = false
        state.loadedActualData = true
    },
    GET_RECONCILIATION_OVERRIDE_ERROR: (state, data) => {
        state.loading = false
    },
    CREATE_RECONCILIATION_OVERRIDE_REQUEST: state => {
        state.loading = true
    },
    CREATE_RECONCILIATION_OVERRIDE_SUCCESS: (state, data) => {
        const reconciliation_overrides = data.reconciliation_overrides
        const removableOverrides = []
        reconciliation_overrides.forEach(i => {
            const {assignable_type, assignable_uuid} = i;
            const existingOverride = state.reconciliationOverrides.find(o => o.assignable_type == assignable_type && o.assignable_uuid == assignable_uuid);
            if(existingOverride){
                removableOverrides.push(existingOverride.uuid);
            }
        })
        state.reconciliationOverrides = state.reconciliationOverrides.filter(i => !removableOverrides.includes(i.uuid));
        state.reconciliationOverrides = addNewFilter(state.reconciliationOverrides, reconciliation_overrides)
        state.loading = false
    },
    CREATE_RECONCILIATION_OVERRIDE_ERROR: (state, data) => {
        state.loading = false
    },
    EDIT_RECONCILIATION_OVERRIDE_REQUEST: state => {
        state.loading = true
    },
    EDIT_RECONCILIATION_OVERRIDE_SUCCESS: (state, data) => {
        state.loading = false
    },
    EDIT_RECONCILIATION_OVERRIDE_ERROR: (state, data) => {
        state.loading = false
    },
    DELETE_RECONCILIATION_OVERRIDE_REQUEST: state => {
        state.loading = true
    },
}

export const reconciliationOverride = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export function unpackReconciliationOverride(reconciliationOverride, commit){
    return reconciliationOverride
}